import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueCurrencyFilter from 'vue-currency-filter'

import './utils/warnings'
import './plugins/vuetify'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './utils/filters'
import './main.scss'
import KeyValueTable from './components/KeyValueTable'
import PageContent from './components/PageContent'
import UserBus from './utils/buses/userBus'

UserBus.init()

Vue.config.productionTip = false

Vue.use(VueCurrencyFilter, {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
})

Vue.component('key-value-table', KeyValueTable)
Vue.component('page-content', PageContent)

Vue.use(VueAnalytics, {
    id: 'UA-40961109-18',
    router
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
